// import Definition from './Definition';

export default {
  priority: 100,
  name: app.translate('routes.home.attendance.stack.packs.Definition'),
  path: 'definition',
  // component: Definition,
  component: load(() => import(/* webpackChunkName: "Stack-Pack-Definition" */ './Definition')),
  permissions: ['StackRulesMenu'],
  icon: 'content-paste',
  drawer: true,
};


